import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=70ca6094"
import script from "./HeaderBlock.vue?vue&type=script&lang=ts"
export * from "./HeaderBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports